// extracted by mini-css-extract-plugin
export var checkoutRateBadge = "_sm-0";
export var checkoutRateBadgeLink = "_sm-1";